// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

type IconListProps = {
  className?: string;
  width?: number;
  height?: number;
  color?: string;
};

const IconList: React.FC<IconListProps> = ({
  className,
  width = 24,
  height = 24,
  color,
}) => (
  <svg
    className={className}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={color || 'currentColor'}
    viewBox="0 0 24 24"
  >
    <path
      fillRule="evenodd"
      d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6Zm4.996 2a1 1 0 0 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM11 8a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm-4.004 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM11 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Zm-4.004 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01ZM11 14a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z"
      clip-rule="evenodd"
    />
  </svg>
);

export default IconList;
